import React, { useState, useEffect } from "react";
import {
  Layout,
  Button,
  Select,
  Avatar,
  Dropdown,
  message,
  Space,
  Modal,
  Input,
} from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
  PhoneOutlined,
  AudioOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import Drawer from "../Drawer";
import "@documate/react/dist/style.css";
import { Documate } from "@documate/react";

import { useSelector, useDispatch } from "react-redux";
import { setSystem } from "../../reducers/systemSlice";
import { setSite } from "../../reducers/siteSlice";
import Search from "../dashboard/Search";
import Upload from "../dashboard/Upload";
import ReactMarkdown from "react-markdown";

const suffix = (
  <AudioOutlined
    style={{
      fontSize: 16,
      color: "#1677ff",
    }}
  />
);

const onClick = ({ key }) => {
  if (key === "1") {
    message.info("แก้ไขข้อมูลส่วนตัว");
    window.location.href = "/profile";
  } else if (key === "2") {
    message.info("ติดต่อเจ้าหน้าที่");
  } else if (key === "3") {
    message.info("ออกจากระบบ");
    localStorage.clear();
    window.location.href = "/";
  }
};

const items = [
  {
    label: "แก้ไขข้อมูลส่วนตัว",
    key: "1",
    icon: <UserOutlined />,
  },
  {
    label: "ติดต่อเจ้าหน้าที่",
    key: "2",
    icon: <PhoneOutlined />,
  },
  {
    label: "ออกจากระบบ",
    key: "3",
    icon: <LogoutOutlined />,
  },
];

const { Header } = Layout;

const HeaderComp = ({ collapsed, setCollapsed, colorBgContainer, isMobile = false }) => {
  const dispatch = useDispatch();
  const selectedSystem = useSelector((state) => state.system.system);
  const selectedSite = useSelector((state) => state.site.site);
  const siteAccount = useSelector((state) => state.site.siteAccount);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const [query, setQuery] = useState(
    "มีเหตุการณ์ผิดปกติไหม ? เกิดวันที่เท่าไหร่ สถานที่ไหน ? อะไรผิดปกติ ? รายงานมาทุกเรื่องเป็นข้อๆ ช่วยแนะนำวิธีแก้ปัญหาด้วย"
  );
  const [siteUuid, setSiteUuid] = useState(
    JSON.parse(localStorage.getItem("site"))
  );
  const [responseData, setResponseData] = useState("");
  const [response, setResponse] = useState("");

  useEffect(() => {
    setSiteUuid(JSON.parse(localStorage.getItem("site")));
  }, [localStorage.getItem("site")]);

  const handleSystemChange = (value) => {
    dispatch(setSystem(value));
  };

  const handleSiteChange = (value) => {
    dispatch(setSite(value));
  };

  const handleQuery = async () => {
    setLoading(true);
    setResponseData("");
    setResponse("");

    const response = await fetch("https://infer-rag.siamai.tech/generate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/event-stream",
      },
      body: JSON.stringify({
        query: query,
        site_uuid: siteUuid,
      }),
    });

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      const chunk = decoder.decode(value);
      try {
        const splitChunks = chunk.split("\n\n");
        splitChunks.forEach((data) => {
          if (data) {
            const match = data.match(/"text":\s*"([^"]*)"/);
            const text = match ? match[1] : "\n";
            setResponseData((prevData) => prevData + text);
          }
        });
      } catch (error) {
        // const splitChunks = JSON.stringify(chunk).split("\n");
        // const parsedData = splitChunks.map((chunk) => JSON.parse(chunk));
        //console.log(error);
      }
    }
  };

  return (
    <Header 
      style={{ 
        padding: 0, 
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
        boxShadow: '0 1px 6px rgba(0, 0, 0, 0.1)',
      }}
      className="fade-in"
    >
      <Modal
        title={
          <div className="text-center">
            <div className="text-lg md:text-2xl font-bold bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
              🤖 แชทกับน้องสายไหม
            </div>
            <div className="text-xs md:text-sm text-gray-500 mt-1">AI Assistant สำหรับระบบรักษาความปลอดภัย</div>
          </div>
        }
        width={isMobile ? '95%' : window.innerWidth < 1024 ? '90%' : 1200}
        open={open}
        onCancel={() => {
          setOpen(false);
          setResponseData("");
          setResponse("");
        }}
        footer={null}
        styles={{
          mask: {
            backdropFilter: "blur(10px)",
            background: "rgba(0, 0, 0, 0.4)",
          },
          content: {
            borderRadius: "20px",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
          },
        }}
        className="modern-modal"
      >
        <div className="space-y-3 md:space-y-4">
          <Input.Search
            placeholder={isMobile ? "🤔 มีเหตุการณ์ผิดปกติไหม?" : "🤔 มีเหตุการณ์ผิดปกติไหม? ถามได้เลยค่ะ..."}
            enterButton={isMobile ? "ถาม" : "ถามน้อง 💬"}
            size={isMobile ? "middle" : "large"}
            onSearch={handleQuery}
            onChange={(e) => {
              setQuery(e.target.value);
            }}
            suffix={suffix}
            style={{
              borderRadius: "12px",
            }}
            className="shadow-sm"
          />
          {responseData ? (
            <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-3 md:p-6 rounded-2xl border border-blue-200">
              <div className="flex items-center mb-2 md:mb-3">
                <div className="w-6 h-6 md:w-8 md:h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mr-2 md:mr-3">
                  <span className="text-white text-xs md:text-sm">🤖</span>
                </div>
                <span className="font-semibold text-gray-800 text-sm md:text-base">น้องสายไหม ตอบ:</span>
              </div>
              <div className="prose prose-blue max-w-none text-sm md:text-base">
                <ReactMarkdown children={responseData} />
              </div>
            </div>
          ) : (
            loading && (
              <div className="flex items-center justify-center p-4 md:p-8">
                <div className="flex items-center space-x-2 md:space-x-3">
                  <div className="animate-spin rounded-full h-5 w-5 md:h-6 md:w-6 border-b-2 border-blue-600"></div>
                  <p className="text-gray-600 text-sm md:text-base">น้องสายไหมกำลังคิด...</p>
                </div>
              </div>
            )
          )}
        </div>
      </Modal>
      <div className="flex justify-between px-2 md:px-4 py-2">
        <div className="flex items-center space-x-1 md:space-x-2">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            className="hover:bg-blue-50 rounded-lg transition-all duration-200"
            style={{
              fontSize: "16px",
              width: 40,
              height: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          />

          <div className="hidden md:flex items-center space-x-3">
            <Upload />
            <Search />
          </div>

          <div className="flex items-center space-x-1 md:space-x-3">
            {/* Mobile: Very compact selects */}
            {isMobile && (
              <>
                <Select
                  showSearch
                  style={{ 
                    width: 90,
                    borderRadius: "6px",
                  }}
                  placeholder="หน่วยงาน"
                  value={siteAccount.length > 0 ? selectedSite : undefined}
                  onChange={handleSiteChange}
                  className="shadow-sm"
                  size="small"
                >
                  {siteAccount?.map((item) => (
                    <Select.Option key={item.site_uuid} value={item.site_uuid}>
                      {item.site_name.length > 8 ? item.site_name.substring(0, 8) + '...' : item.site_name}
                    </Select.Option>
                  ))}
                </Select>

                <Select
                  style={{ 
                    width: 70,
                    borderRadius: "6px",
                  }}
                  placeholder="ระบบ"
                  value={selectedSystem}
                  onChange={handleSystemChange}
                  className="shadow-sm"
                  size="small"
                  options={[
                    { value: 1, label: "VMS" },
                    { value: 2, label: "Patrol" },
                    { value: 3, label: "Time" },
                    { value: 4, label: "Report" },
                    { value: 5, label: "Center" },
                  ]}
                />
              </>
            )}

            {/* Tablet: Medium selects */}
            <div className="hidden md:block lg:hidden">
              <Select
                showSearch
                style={{ 
                  width: 120,
                  borderRadius: "8px",
                }}
                placeholder="หน่วยงาน"
                value={siteAccount.length > 0 ? selectedSite : undefined}
                onChange={handleSiteChange}
                className="shadow-sm text-xs"
                size="small"
              >
                {siteAccount?.map((item) => (
                  <Select.Option key={item.site_uuid} value={item.site_uuid}>
                    {item.site_name}
                  </Select.Option>
                ))}
              </Select>
            </div>

            <div className="hidden md:block lg:hidden">
              <Select
                showSearch
                style={{ 
                  width: 100,
                  borderRadius: "8px",
                }}
                placeholder="ระบบ"
                value={selectedSystem}
                onChange={handleSystemChange}
                className="shadow-sm text-xs"
                size="small"
                options={[
                  { value: 1, label: "VMS" },
                  { value: 2, label: "Patrol" },
                  { value: 3, label: "Time" },
                  { value: 4, label: "Report" },
                  { value: 5, label: "Central" },
                ]}
              />
            </div>

            {/* Desktop: Full selects */}
            <div className="hidden lg:block">
              <Select
                showSearch
                style={{ 
                  width: 200,
                  borderRadius: "8px",
                }}
                placeholder="🏢 หน่วยงาน"
                value={siteAccount.length > 0 ? selectedSite : "กำลังโหลดข้อมูล..."}
                onChange={handleSiteChange}
                className="shadow-sm"
              >
                {siteAccount?.map((item) => (
                  <Select.Option key={item.site_uuid} value={item.site_uuid}>
                    <div className="flex items-center">
                      <span className="mr-2">🏢</span>
                      {item.site_name}
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </div>

            <div className="hidden lg:block">
              <Select
                showSearch
                style={{ 
                  width: 200,
                  borderRadius: "8px",
                }}
                placeholder="⚙️ ระบบ"
                value={selectedSystem}
                onChange={handleSystemChange}
                className="shadow-sm"
                options={[
                  { value: 1, label: "📹 VMS" },
                  { value: 2, label: "🚶‍♂️ Guard Patrolling" },
                  { value: 3, label: "⏰ Time Attendance" },
                  { value: 4, label: "📊 Daily Report" },
                  { value: 5, label: "🎯 Centralize" },
                ]}
              />
            </div>
          </div>
          {/* <Documate
            endpoint="https://infer-llm.siamai.tech/ask"
            buttonLabel="ถามน้องสายไหม"
            placeholder="น้องสายไหม ยินดีให้คำปรึกษาค่ะ และช่วยธุรกิจของคุณ ถามได้เลย"
            predefinedQuestions={[
              "วิธีการลดกำลังคน บริษัทรักษาความปลอดภัย?",
              "วิธีการนำเทคโนโลยี AI มาใช้ในการรักษาความปลอดภัย?",
              "วิธีการใช้เทคโนโลยี IoT ในการรักษาความปลอดภัย?",
            ]}
          /> */}
          <Button
            type="primary"
            className="gradient-button shadow-lg hover:shadow-xl transition-all duration-300"
            style={{
              background: "linear-gradient(45deg, #ff6b6b, #f06595)",
              border: "none",
              borderRadius: isMobile ? "6px" : "8px",
              height: isMobile ? "32px" : "36px",
              fontWeight: "600",
              fontSize: isMobile ? "11px" : "12px",
              padding: isMobile ? "0 8px" : "0 12px",
            }}
            icon={isMobile ? <MessageOutlined style={{ fontSize: '12px' }} /> : <MessageOutlined />}
            onClick={() => {
              setOpen(true);
            }}
            size={isMobile ? "small" : "middle"}
          >
            {isMobile ? "AI" : (
              <>
                <span className="hidden sm:inline">ถามน้องสายไหม</span>
                <span className="sm:hidden">AI</span>
              </>
            )}
          </Button>
        </div>
        
        <div className="flex items-center space-x-1 md:space-x-3">
          <div className="hidden md:block">
            <Drawer />
          </div>
          <Dropdown 
            placement="bottomRight" 
            menu={{ items, onClick }}
            trigger={['click']}
          >
            <div className={`flex items-center ${isMobile ? 'space-x-1' : 'space-x-2'} cursor-pointer hover:bg-gray-50 rounded-lg ${isMobile ? 'p-1' : 'p-2'} transition-all duration-200`}>
              <Avatar
                size={isMobile ? 28 : 32}
                style={{ 
                  backgroundColor: "#667eea",
                  border: isMobile ? "1px solid rgba(255, 255, 255, 0.8)" : "2px solid rgba(255, 255, 255, 0.8)",
                }}
                icon={<UserOutlined style={{ fontSize: isMobile ? '14px' : '16px' }} />}
                className="shadow-md"
              />
              {!isMobile && (
                <div className="hidden lg:block text-right">
                  <div className="text-sm font-semibold text-gray-700">ผู้ใช้งาน</div>
                  <div className="text-xs text-gray-500">คลิกเพื่อจัดการบัญชี</div>
                </div>
              )}
            </div>
          </Dropdown>
        </div>
      </div>
    </Header>
  );
};

export default HeaderComp;
